var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elementIcono9IUN-eSSK3VklWQbrQnB",
    clipPath: "url(#clip0_6403_97826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5581 5.62236H5.46655V18.7668H8.5581V5.62236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.8333 18.7667V15.7333H5.46705V18.7667H17.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.0942 8.65562C18.4902 8.65562 19.622 7.5239 19.622 6.12784C19.622 4.73179 18.4902 3.60006 17.0942 3.60006C15.6981 3.60006 14.5664 4.73179 14.5664 6.12784C14.5664 7.5239 15.6981 8.65562 17.0942 8.65562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6403_97826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(-2 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinea);
export default __webpack_public_path__ + "static/media/icon-linea.102ee3c671d9aed73d9207afa85f60c6.svg";
export { ForwardRef as ReactComponent };